import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Alert, LoadingBlock } from '../components/ui';

/** Exchanges the Cognito authorization code for tokens, then enters the portal. */
export function CallbackPage() {
  const { completeSignIn } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // StrictMode double-invokes effects in development; the code may only be
  // redeemed once, so the attempt is guarded.
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    completeSignIn()
      .then(() => navigate('/admin', { replace: true }))
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Sign-in could not be completed.');
      });
  }, [completeSignIn, navigate]);

  return (
    <div className="admin">
      <main className="admin-main">
        <div className="container">
          {error ? (
            <div className="card stack" style={{ maxWidth: '32rem', margin: '0 auto' }}>
              <Alert variant="error" title="Sign-in failed">
                <p style={{ marginBottom: 0 }}>{error}</p>
              </Alert>
              <div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate('/admin', { replace: true })}
                >
                  Try again
                </button>
              </div>
            </div>
          ) : (
            <LoadingBlock message="Completing sign-in..." />
          )}
        </div>
      </main>
    </div>
  );
}
